import axios from "axios";
import store from "@/common/store";
const URL = process.env.VUE_APP_BACKEND_API_URL;
const VERSION = process.env.VUE_APP_BACKEND_API_URL_VERSION;
import {getGlobalSearchOffersByCriteria} from "@/gop/services/gop.service";
import {LANGUAGE_ARRAY} from "@/common/utils/constants";
import {fetchProjects} from "@/drc/services/drc-request-service";

export function getGlobalSearchProjects(text, language) {
	return new Promise(() => {
		Promise.all([
			getByText(text, language),
			getByToolName(text, language),
			getByCertificateName(text, language),
			getTop6(6, language),
			getByCompanyName(text, language),
			getByBusinessManagerName(text, language),
			getByDeliveryManagerName(text, language),
			getByOwnerName(text, language),
			getByOffersTextContaining(text, language)
		])
			.then(() => {
				store.dispatch('setGlobalSearchResult', {
					resultName: 'word',
					payload: decodeURIComponent(text)
				});
				store.dispatch('setGlobalSearchResult', {
					resultName: 'showResults',
					payload: true
				});
			})
			.catch((error) => {
				console.error(error)
			});
	});
}

export function getByText(text, language) {
	return fetchProjects({text, language} )
		.then((response) => {return {name: 'projectsByText', payload: response}})
		.catch((error) => {return {name: 'projectsByText', error: error}});
}

export function getByToolName(toolName, language) {
	toolName = encodeURIComponent(toolName);
	return axios.get(`${URL}/old-projects/global-search/tools?toolName=${toolName}&language=${language}`)
		.then((response) => {return {name: 'projectsByTool', payload: response.data}})
		.catch((error) => {return {name: 'projectsByTool', error: error}});
}

export function getByCertificateName(competencyName, language) {
	competencyName = encodeURIComponent(competencyName);
	return axios.get(`${URL}/old-projects/global-search/certifications?certificationName=${competencyName}&language=${language}`)
		.then((response) => {return {name: 'projectsByCertification', payload: response.data}})
		.catch((error) => {return {name: 'projectsByCertification', error: error}});
}

export function getTop6(number, language) {
	return axios.get(`${URL}/old-projects/search-get-newest?page=0,desc&count=${number}&language=${language}&size=${number}`)
		.then((response) => {return {name: 'top6Projects', payload: response.data}})
		.catch((error) => {return {name: 'top6Projects', error: error}});
}

export function getByCompanyName(companyName, language) {
	companyName = encodeURIComponent(companyName);
	return axios.get(`${URL}/old-projects/global-search/companies?companyName=${companyName}&language=${language}`)
		.then((response) => {return {name: 'projectsByCompany', payload: response.data}})
		.catch((error) => {return {name: 'projectsByCompany', error: error}});
}

export function getByBusinessManagerName(businessManagerName, language) {
	businessManagerName = encodeURIComponent(businessManagerName);
	return axios.get(`${URL}/old-projects/global-search/business-contact-managers?businessContactManager=${businessManagerName}&language=${language}`)
		.then((response) => {return {name: 'projectsByBusinessContactManager', payload: response.data}})
		.catch((error) => {return {name: 'projectsByBusinessContactManager', error: error}});
}

export function getByDeliveryManagerName(deliveryManagerName, language) {
	deliveryManagerName = encodeURIComponent(deliveryManagerName);
	return axios.get(`${URL}/old-projects/global-search/delivery-contact-managers?deliveryContactManager=${deliveryManagerName}&language=${language}`)
		.then((response) => {return {name: 'projectsByDeliveryContactManager', payload: response.data}})
		.catch((error) => {return {name: 'projectsByDeliveryContactManager', error: error}});
}

export function getByOwnerName(ownerName, language) {
	ownerName = encodeURIComponent(ownerName);
	return axios.get(`${URL}/old-projects/global-search/reference-owners?referenceOwnerName=${ownerName}&language=${language}`)
		.then((response) => {return {name: 'projectsByOwner', payload: response.data}})
		.catch((error) => {return {name: 'projectsByOwner', error: error}});
}

export function getByRelatedOffersTextContaining(text) {
	text = encodeURIComponent(text);
	return axios.get(`${URL}/old-projects/global-search/related-offers?text=${text}`)
		.then((response) => {return {name: 'projectsByRelatedOffers', payload: response.data}})
		.catch((error) => {return {name: 'projectsByRelatedOffers', error: error}});
}

export function getByOffersTextContaining(text, language) {
	const criteria = {
		contentLanguageId: LANGUAGE_ARRAY.find(lang => lang.short === language).id,
		isManagement: false
	};
	return getGlobalSearchOffersByCriteria(criteria, text, 0, 100000)
		.then((response) => {return {name: 'offers', payload: response.data.data.searchOfferByCriteria}})
		.catch((error) => {return {name: 'offers', error: error}});
}




function getOffers(text, language) {
	const criteria = {
		contentLanguageId: LANGUAGE_ARRAY.find(lang => lang.short === language).id,
		isManagement: false
	};
	return getGlobalSearchOffersByCriteria(criteria, text, 0, 100000)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'offers',
				payload: response.data.data.searchOfferByCriteria
			});
		})
		.catch((error) => console.error(error));
}

function getStories(text, language) {
	return axios.get(`${URL}/old-projects/global-search?text=${text}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByText',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

function getProjectsByToolName(toolName, language) {
	return axios.get(`${URL}/old-projects/global-search/tools?toolName=${toolName}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByTool',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

function getProjectsByCertificateName(competencyName, language) {
	return axios.get(`${URL}/old-projects/global-search/certifications?certificationName=${competencyName}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByCertification',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}
function getTop5(number,language) {

	return axios.get(`${URL}/old-projects/search-get-newest?page=0,desc&count=${number}&language=${language}&size=5`)
		.then((response)  => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'top5Projects',
				payload: response.data,
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

function getProjectsByCompanyName(companyName, language) {
	return axios.get(`${URL}/old-projects/global-search/companies?companyName=${companyName}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByCompany',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

function getProjectsByOwnerName(ownerName, language) {
	return axios.get(`${URL}/old-projects/global-search/reference-owners?referenceOwnerName=${ownerName}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByOwner',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

function getProjectsByBusinessManagerName(businessManagerName, language) {
	return axios.get(`${URL}/old-projects/global-search/business-contact-managers?businessContactManager=${businessManagerName}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByBusinessContactManager',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

function getProjectsByDeliveryManagerName(deliveryManagerName, language) {
	return axios.get(`${URL}/old-projects/global-search/delivery-contact-managers?deliveryContactManager=${deliveryManagerName}&language=${language}`)
		.then((response) => {
			store.dispatch('setGlobalSearchResult', {
				resultName: 'projectsByDeliveryContactManager',
				payload: response.data
			});
		})
		.catch((error) => {
			console.error(error)
		});
}

export function getResults(text, language) {
	text = encodeURIComponent(text.trim())
	return new Promise(() => {
		Promise.all([
			getStories(text, language),
			getProjectsByToolName(text, language),
			getProjectsByCertificateName(text, language),
			getTop5(5,language),
			getProjectsByCompanyName(text, language),
			getProjectsByBusinessManagerName(text, language),
			getProjectsByDeliveryManagerName(text, language),
			getProjectsByOwnerName(text, language),
			getOffers(text, language)
		])
			.then(() => {
				store.dispatch('setGlobalSearchResult', {
					resultName: 'word',
					payload: decodeURIComponent(text)
				});
				store.dispatch('setGlobalSearchResult', {
					resultName: 'showResults',
					payload: true
				});
			})
			.catch((error) => {
				console.error(error)
				store.dispatch('setGlobalSearchResult', {
					resultName: 'showResults',
					payload: false
				});
			});
	});
}
